const KL_KLAVIYO_WISHLIST_TOGGLE_EVENT = 'kl:wishlist:toggle';
const KL_KLAVIYO_NOTIFY_ME_EVENT = 'kl:notify-me:subscribed';

const KL_KLAVIYO_WISHLIST_ADDED_METRIC = 'Wishlist Added';
const KL_KLAVIYO_WISHLIST_REMOVED_METRIC = 'Wishlist Removed';
const KL_KLAVIYO_BACK_IN_STOCK_METRIC = 'Back In Stock Subscribed';

const KL_KLAVIYO_CENTS_IN_MAJOR_UNIT = 100;
const KL_KLAVIYO_TRACK_COMMAND = 'track';
const KL_KLAVIYO_IDENTIFY_COMMAND = 'identify';

function klKlaviyoToMajorUnit(centsValue) {
  const centsText = String(centsValue || '').trim();

  if (centsText === '') return undefined;

  const cents = Number(centsText);

  if (!Number.isFinite(cents)) return undefined;

  return cents / KL_KLAVIYO_CENTS_IN_MAJOR_UNIT;
}

function klKlaviyoToNumericId(idValue) {
  const idText = String(idValue || '').trim();
  const numericText = idText.slice(idText.lastIndexOf('/') + 1);

  if (numericText === '') return null;

  const numericId = Number(numericText);

  return Number.isFinite(numericId) ? numericId : null;
}

function klKlaviyoParseTags(tagList) {
  return String(tagList || '')
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean);
}

function klKlaviyoCompact(payload) {
  const compacted = {};

  Object.keys(payload).forEach((propertyName) => {
    const value = payload[propertyName];

    if (value === undefined || value === '') return;
    if (Array.isArray(value) && value.length === 0) return;

    compacted[propertyName] = value;
  });

  return compacted;
}

function klKlaviyoSend(commandArguments) {
  const commandName = commandArguments[0];

  try {
    const klaviyo = window.klaviyo;

    if (klaviyo && typeof klaviyo.push === 'function') {
      klaviyo.push(commandArguments);
      return;
    }

    if (klaviyo && typeof klaviyo[commandName] === 'function') {
      klaviyo[commandName].apply(klaviyo, commandArguments.slice(1));
      return;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(commandArguments);
  } catch (error) {
    console.debug('kl-klaviyo: could not hand an event to Klaviyo', { commandName, error });
  }
}

function klKlaviyoTrack(metricName, payload) {
  klKlaviyoSend([KL_KLAVIYO_TRACK_COMMAND, metricName, klKlaviyoCompact(payload)]);
}

function klKlaviyoIdentify(profile) {
  klKlaviyoSend([KL_KLAVIYO_IDENTIFY_COMMAND, klKlaviyoCompact(profile)]);
}

function klKlaviyoToAbsoluteUrl(pathValue) {
  const path = String(pathValue || '').trim();

  if (path === '') return undefined;

  try {
    return new URL(path, window.location.origin).href;
  } catch (error) {
    console.debug('kl-klaviyo: could not resolve a URL against this origin', { path, error });
    return undefined;
  }
}

function klKlaviyoBuildWishlistPayload(button, detail) {
  const data = button.dataset;

  return {
    productId: data.klWishlistProduct,
    productIdNumeric: klKlaviyoToNumericId(data.klWishlistProduct),
    productTitle: data.klWishlistTitle,
    productHandle: data.klWishlistHandle,
    productUrl: klKlaviyoToAbsoluteUrl(data.klWishlistUrl),
    productImage: klKlaviyoToAbsoluteUrl(data.klWishlistImage),
    price: klKlaviyoToMajorUnit(data.klWishlistPriceCents),
    currency: data.klWishlistCurrency,
    variantId: data.klWishlistVariant,
    variantIdNumeric: klKlaviyoToNumericId(data.klWishlistVariant),
    variantTitle: data.klWishlistVariantTitle,
    tags: klKlaviyoParseTags(data.klWishlistTags),
    wishlistCount: detail.wishlistCount,
  };
}

function klKlaviyoBuildNotifyMePayload(detail) {
  return {
    productId: detail.productId,
    productIdNumeric: klKlaviyoToNumericId(detail.productId),
    productTitle: detail.productTitle,
    productHandle: detail.productHandle,
    productUrl: klKlaviyoToAbsoluteUrl(detail.productUrl),
    productImage: klKlaviyoToAbsoluteUrl(detail.productImage),
    price: klKlaviyoToMajorUnit(detail.priceCents),
    currency: detail.currency,
    variantId: detail.variantId,
    variantIdNumeric: klKlaviyoToNumericId(detail.variantId),
    email: detail.email,
  };
}

document.addEventListener(KL_KLAVIYO_WISHLIST_TOGGLE_EVENT, (event) => {
  const button = event.target;
  const detail = event.detail;

  if (!button || !button.dataset || !detail) return;

  const metricName = detail.isActive
    ? KL_KLAVIYO_WISHLIST_ADDED_METRIC
    : KL_KLAVIYO_WISHLIST_REMOVED_METRIC;

  klKlaviyoTrack(metricName, klKlaviyoBuildWishlistPayload(button, detail));
});

document.addEventListener(KL_KLAVIYO_NOTIFY_ME_EVENT, (event) => {
  const detail = event.detail;

  if (!detail) return;

  if (detail.email) klKlaviyoIdentify({ email: detail.email });

  klKlaviyoTrack(KL_KLAVIYO_BACK_IN_STOCK_METRIC, klKlaviyoBuildNotifyMePayload(detail));
});
